import "react-toastify/dist/ReactToastify.css";
import { TitleWithDivider } from "@common/TitleWithDivider";
import { ConfirmCancelButtons } from "@components/Buttons/ConfirmCancelButtons";
import messages from "@constants/Messages";
import pageHeaders from "@constants/PageHeaders";
import UserImageTable from "@components/Tables/UserImageTable";
import LoadingIcon from "@common/LoadingIcon";
import PaginationControls from "@services/PaginationControls";
import { UseUserPhotoUploadPage } from "@pages/User/UserPhotoUploadPage/hooks/UseUserPhotoUploadPage";

const UserPhotoUploadPage: React.FC = () => {
  const form = UseUserPhotoUploadPage();

  return (
    <div>
      <TitleWithDivider
        titleText={pageHeaders.USER.photoUpload}
        useDivider={true}
      />
      {form.doingUpload && (
        <div className="fixed inset-0 z-50 flex items-center justify-center backdrop-brightness-50 min-h-screen">
          <div className="bg-white bg-opacity-95 p-5 rounded-lg shadow-lg flex items-center justify-center">
            <LoadingIcon bodyText={messages.image.uploading} />
          </div>
        </div>
      )}
      {form.loading ? (
        <div className="flex items-center justify-center h-40 rounded-xl">
          <LoadingIcon />
        </div>
      ) : (
        <>
          <UserImageTable
            selectedUsers={form.selectedUsers}
            setSelectedUsers={form.setSelectedUsers}
            setFileMap={form.setFileMap}
            userInformation={form.userData}
          ></UserImageTable>

          <p className="ml-5 mt-2 text-md text-red-400">
            {messages.image.icon_hint}
          </p>

          <PaginationControls
            currentPage={form.currentPage}
            totalPages={form.totalPages}
            totalItems={form.totalUsers}
            displayedItem={"社内電話帳"}
            onPageChange={form.handlePageChange}
            setPerPage={form.setItemsPerPage}
            perPage={form.itemsPerPage}
          />

          {Object.keys(form.fileMap).length > 0 ? (
            <ConfirmCancelButtons
              confirmText={"インポート"}
              onCancel={form.onCancel}
              onConfirm={form.handleUpload}
            />
          ) : (
            <div className="flex justify-end mt-5">
              <button className="button-cancel" onClick={form.onCancel}>
                キャンセル
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default UserPhotoUploadPage;
